import { css } from '@emotion/react';

export const Folding = {
  fold: (isOpen: boolean) => css`
    transition: height 0.3s ease, opacity 0.3s ease;
    // overflow: hidden;
    height: ${isOpen ? 'auto' : '0'};
    opacity: ${isOpen ? 1 : 0};
  `,
};
